import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import {
  ProviderInterface,
  setEditId,
  setEditError,
  selectProviderById
} from "src/store/callrecorder/providersSlice";
import {
  updateProvider,
  fetchProvider
} from "src/actions/callrecorder/providersActions";

import DrawerRight from "src/componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "src/componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.callrecorder.providers.editId);
  const error   = useAppSelector(state => state.callrecorder.providers.editError);
  const provider = useAppSelector(state => selectProviderById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchProvider(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: ProviderInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: ProviderInterface) {
    const resultAction = await dispatch(updateProvider({ id, data }));

    if (updateProvider.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-provider'>
        <h6 className="v-content-label">Edit Provider</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={provider} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
